import { render, staticRenderFns } from "./ContractType.vue?vue&type=template&id=28c8a4da"
import script from "./ContractType.vue?vue&type=script&lang=js"
export * from "./ContractType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports